import { generateClient } from "aws-amplify/api";
import { getBglData, getSurveyBySurveyIdByStatus } from "../graphql/queries";

const client = generateClient();

const surveyService = {
  getSurveyBySurveyIdByStatus: async (surveyId, status) => {
    const response = await client.graphql({
      query: getSurveyBySurveyIdByStatus,
      authMode: "apiKey",
      variables: { surveyId, status: { eq: status } },
    });
    return response;
  },
};

export default surveyService;
